// Functionality adding multiple addon products to cart
const addons = document.querySelectorAll('[data-addon]');
if (addons.length) {
  addons.forEach(addon => {
    const inputs = addon.querySelectorAll('input');
    // inputs.forEach(input => {
    //   input.addEventListener('change', () => {
        
    //   });
    // });
  });
  
  const buyBtn = document.querySelector('[data-add-to-cart]');
  const productSelect = document.querySelector('[data-product-select]');
  const optionGroups = document.querySelectorAll('[data-option-group]');
  const selectedAddons = {items: []};
  const date = new Date().getTime();
    
  buyBtn.addEventListener('click', (event) => {
    event.preventDefault();

    const checkInput = Array.from(optionGroups).every(optionGroup => {
      const input = optionGroup.querySelector('input:checked');
      if (input) {
        return true;
      } else {
        return false;
      }
    });

    if (checkInput) {
      selectedAddons.items.push({
        id: productSelect.value,
        quantity: 1,
        properties: {
          addon: 'main',
          date: `${date}-${productSelect.value}`,
          Leveringstid: '7-9 uger.' // Ensure Leveringstid is added
        }
      });

      addons.forEach(addon => {
        const input = addon.querySelector('input:checked');
        if (input) {
          selectedAddons.items.push({
            id: input.value,
            quantity: 1,
            properties: {
              addon: true,
              date: `${date}-${productSelect.value}`
            }
          });
        }
      });

      // Debugging: Log the selectedAddons object
      console.log('Selected Addons:', selectedAddons);

      addToCart(selectedAddons);
      selectedAddons.items = [];
    } else {
      const y = optionGroups[0].getBoundingClientRect().top + window.scrollY - 200;
      window.scroll({
        top: y,
        behavior: 'smooth'
      });
    }

    optionGroups.forEach(optionGroup => {
      const input = optionGroup.querySelector('input:checked');
      const error = optionGroup.querySelector('[data-option-error]');
      if (!input) {
        error.classList.add('error');
      } else {
        error.classList.remove('error');
      }
    });
  });
}

window.addToCart = function (productData) {
  // Debugging: Log the productData being sent to the cart
  console.log('Product Data Sent to Cart:', productData);

  fetch(theme.routes.cartAdd, {
    method: 'POST',
    body: JSON.stringify(productData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(response => response.json())
    .then(function (data) {
      if (data.status === 422) {
        console.error('Error Adding to Cart:', data);
      } else {
        var product = data;
        console.log('Cart Response:', data);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product[0] || product,
            addToCartBtn: buyBtn
          }
        }));
      }
    });
};

window.removeFromCart = function(productData, callback = null) {
  // Debugging: Log the productData being sent to update the cart
  console.log('Product Data Sent to Update Cart:', productData);

  fetch('/cart/update.js', {
    method: 'POST',
    body: JSON.stringify(productData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(function(data) {
    if (data.status === 422) {
      console.error('Error Updating Cart:', data);
    } else {
      console.log('Cart Update Response:', data);
      if (callback !== null) {
        callback(); 
      }
    }
  });
};

function cartAddonEvent() {
  const cartAddons = document.querySelectorAll('[data-toggle-addons]');
  cartAddons.forEach(cartAddon => {
    const drawer = cartAddon.nextElementSibling;
    const itemAddons = drawer.querySelectorAll('[data-item-addon]');
    cartAddon.addEventListener('click', () => {
      drawer.classList.add('active');
    });

    const drawerCloseBtn = drawer.querySelector('[data-addon-close]');
    drawerCloseBtn.addEventListener('click', () => {
      drawer.classList.remove('active');
    });

    const submit = drawer.querySelector('[data-submit]');
    submit.addEventListener('click', () => {
      const newDate = new Date().getTime();
      const ids = {items: []};
      itemAddons.forEach(addon => {
        const input = addon.querySelector('input:checked');
        if (input) {
          ids.items.push({ id: input.value, quantity: 1, properties: { addon: true, date: `${newDate}-${itemAddons[0].dataset.itemAddon}` } });
        }
      });
      ids.items.push({ id: +itemAddons[0].dataset.itemAddon, quantity: 1, properties: { addon: 'main', date: `${newDate}-${itemAddons[0].dataset.itemAddon}` } });
  
      const currentAddonsElements = document.querySelectorAll(`.cart__item[data-id="${drawer.dataset.itemId}"]`);
      if (currentAddonsElements.length) {
        const currentAddons = Array.from(currentAddonsElements).map(i => i.dataset.key);
        const object = {};
        currentAddons.forEach(currentAddon => {
          object[currentAddon] = 0;
        });
        removeFromCart({ updates: object }, function () {
          addToCart(ids);
        })
      }
    });
  });

  const openItemAddonPopups = document.querySelectorAll('[data-item-open-addon-popup]');
  if (openItemAddonPopups.length) {
    openItemAddonPopups.forEach(openItemAddonPopup => {
      const popup = document.querySelector(`[data-item-open-addon-modal="${openItemAddonPopup.dataset.itemAddonIndex}"]`);
      openItemAddonPopup.addEventListener('click', () => {
        popup.classList.add('active');
      });

      const closeBtns = document.querySelectorAll('[data-item-close]');
      closeBtns.forEach(close => {
        close.addEventListener('click', () => {
          popup.classList.remove('active');
        });
      });
    });

    const openAddonPopups = document.querySelectorAll('[data-item-open-addon-popup]');
    openAddonPopups.forEach(openAddonPopup => {
      const chooseBtn = openAddonPopup.parentElement.querySelector('[data-addon-choose]');
      const removeBtn = openAddonPopup.parentElement.parentElement.querySelector('[data-item-remove]');
      chooseBtn.addEventListener('click', () => {
        const input = openAddonPopup.parentElement.querySelector('input:checked');
        if (input) {
          const activeLabel = document.querySelector(`[data-item-addon-index="${openAddonPopup.dataset.itemAddonIndex}"]`);
          if (activeLabel) {
            activeLabel.querySelector('span').textContent = input.dataset.name;
          }
          const popup = document.querySelector(`[data-item-open-addon-modal="${openAddonPopup.dataset.itemAddonIndex}"]`);
          popup.classList.remove('active');
        }
      });
      if (removeBtn) {
        removeBtn.addEventListener('click', () => {
          const key = removeBtn.dataset.itemRemove;
          const object = {};
          object[key] = 0;
          removeFromCart({ updates: object }, function () {
            document.dispatchEvent(new CustomEvent('cart:build'));
          })
        });
      }
    });
  }
}

document.addEventListener('cart:updated', function() {
  cartAddonEvent();
  const cartAddons = document.querySelectorAll('.item-addon-drawer');
  cartAddons.forEach(cartAddon => {
    const checkedInputs = cartAddon.querySelectorAll('input:checked');
    const cartItem = cartAddon.closest('.cart__item');
    const priceElement = cartItem.querySelector('[data-price-element]');
    const price = +priceElement.dataset.price;
    const pricesArray = [];
    checkedInputs.forEach(input => {
      pricesArray.push(+input.dataset.price);
    });
    pricesArray.push(price);
    const totalPrice = pricesArray.reduce((a, b) => a + b, 0);
    priceElement.textContent = `${theme.Currency.formatMoney(totalPrice)}`;
  });
});


// Open addon popup, choose addons
const openAddonPopups = document.querySelectorAll('[data-open-addon-popup]');
openAddonPopups.forEach(openAddonPopup => {
  const chooseBtn = openAddonPopup.parentElement.querySelector('[data-addon-choose]');
  chooseBtn.addEventListener('click', () => {
    const input = openAddonPopup.parentElement.querySelector('input:checked');
    if (input) {
      const activeLabel = document.querySelector(`[data-addon-index="${openAddonPopup.dataset.addonIndex}"]`);
      if (activeLabel) {
        activeLabel.querySelector('span').textContent = input.dataset.name;
      }
      const popup = document.querySelector(`[data-open-addon-modal="${openAddonPopup.dataset.addonIndex}"]`);
      popup.classList.remove('active');
    }
  });
});

const openAddonReadMore = document.querySelectorAll('[data-addon-read-more]');
if (openAddonReadMore.length) {
  openAddonReadMore.forEach(open => {
    const readmoreModal = document.querySelector(`[data-read-more-modal="${open.dataset.addonReadIndex}"]`);

    open.addEventListener('click', () => {
      readmoreModal.classList.add('active');
    });

    const closeBtns = document.querySelectorAll('[data-close]');
    closeBtns.forEach(close => {
      close.addEventListener('click', () => {
        readmoreModal.classList.remove('active');
      });
    });
  })
}

if (openAddonPopups.length) {
  openAddonPopups.forEach(openAddonPopup => {
    const popup = document.querySelector(`[data-open-addon-modal="${openAddonPopup.dataset.addonIndex}"]`);
    openAddonPopup.addEventListener('click', () => {
      popup.classList.add('active');
    });

    const closeBtns = document.querySelectorAll('[data-close]');
    closeBtns.forEach(close => {
      close.addEventListener('click', () => {
        popup.classList.remove('active');
      });
    });
  });
}

const addonLabels = document.querySelectorAll('[data-addon-labels]');
if (addonLabels.length) {
  addonLabels.forEach(addonLabel => {
    const input = addonLabel.querySelector('input');
    input.addEventListener('change', () => {
      addonLabels.forEach(addonLabel => {
        addonLabel.classList.remove('active');
      });
      addonLabel.classList.add('active');
    });
  });
}

